// test2725
(2725 && 0);
